// src/components/ErrorBoundary.jsx
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, info: null, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Можно сюда подключить отправку в ваш логгер/сентри
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Caught error:', error, info);
    this.setState({ info });
  }

  handleReload = () => window.location.reload();
  handleReset  = () => this.setState({ hasError: false, info: null, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        maxWidth: 760, margin: '40px auto', padding: 16,
        border: '1px solid var(--bdr)', borderRadius: 16, background: 'var(--card)',
        boxShadow: 'var(--shadow)', fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif'
      }}>
        <h2 style={{ marginTop: 0 }}>Что-то пошло не так</h2>
        <p style={{ opacity: .8, marginTop: 6 }}>
          Мы поймали ошибку и скрыли крэш. Попробуйте обновить страницу.
        </p>

        {this.state.error && (
          <details style={{ whiteSpace: 'pre-wrap', marginTop: 12 }}>
            <summary style={{ cursor: 'pointer' }}>Детали</summary>
            <div style={{ marginTop: 8 }}>
              <code>{String(this.state.error?.message || this.state.error)}</code>
            </div>
            {this.state.info?.componentStack && (
              <pre style={{ fontSize: 12, opacity: .8, marginTop: 8 }}>
                {this.state.info.componentStack}
              </pre>
            )}
          </details>
        )}

        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button className="btn btn-primary" onClick={this.handleReload}>Обновить</button>
          <button className="btn" onClick={this.handleReset}>Закрыть</button>
        </div>
      </div>
    );
  }
}
